import { ActionReducerMapBuilder } from '@reduxjs/toolkit'
import { AppState } from '@store/slices/generic.slice'
import {
  AudioMessageModel,
  audioNewsAdapterExport,
} from '@store/slices/audioMessage.slice'
import {
  createAudioMessageFromFile,
  updateAudioMessageWithFile,
} from '@store/thunk/audioMessage.thunk'

export const audioMessageExtraReducers = (
  builder: ActionReducerMapBuilder<AppState<AudioMessageModel>>
) => {
  builder
    .addCase(createAudioMessageFromFile.pending, (state) => {
      state.loading = true
      state.error = null
    })
    .addCase(createAudioMessageFromFile.fulfilled, (state, action) => {
      audioNewsAdapterExport.upsertOne(state, action.payload)
      state.loading = false
    })
    .addCase(createAudioMessageFromFile.rejected, (state) => {
      state.loading = false
      state.error = `Unable to create audio message`
    })
    .addCase(updateAudioMessageWithFile.pending, (state) => {
      state.loading = true
      state.error = null
    })
    .addCase(updateAudioMessageWithFile.fulfilled, (state, action) => {
      audioNewsAdapterExport.upsertOne(state, action.payload)
      state.loading = false
    })
    .addCase(updateAudioMessageWithFile.rejected, (state) => {
      state.loading = false
      state.error = `Unable to create audio message`
    })
}
